import { useTranslation } from 'react-i18next';
import { StatusPill } from '@/components/ui';
import { useDesign } from '@/hooks/useDesigns';
import { useDesignStore } from '@/stores';

/**
 * Tells the seller in the creator header that the saved design differs
 * from what was last published: print and shop follow only with a new
 * publish. The API decides on the seller fingerprint, so a new title or
 * tags never raise it, and nothing shows before the first publish.
 */
export function UnpublishedChangesBadge() {
  const { t } = useTranslation();
  const designId = useDesignStore((state) => state.designId);
  const { data: design } = useDesign(designId ?? undefined);

  if (!design?.hasUnpublishedChanges) return null;
  return (
    <StatusPill variant="warning" className="shrink-0">
      {t('creator.header.unpublishedChanges')}
    </StatusPill>
  );
}
